import { useEffect, useState } from 'react';

import QuantityInput from './QuantityInput';
import QuantitySelect from './QuantitySelect';

const QuantityEditable = (props) => {
  const { item, onIsQuantityUpdating, isGiftCard } = props;

  const [fieldType, setFieldType] = useState(
    item.quantity <= 12 ? 'Select' : 'Input'
  );

  const { quantity } = item;

  useEffect(() => {
    if (quantity < 12) {
      setFieldType('Select');
    } else {
      setFieldType('Input');
    }
  }, [quantity]);

  if (isGiftCard) {
    return <div className="c7-order-item__quantity">{item.quantity}</div>;
  }

  if (fieldType === 'Select') {
    return (
      <QuantitySelect
        item={item}
        onSetFieldType={setFieldType}
        onIsQuantityUpdating={onIsQuantityUpdating}
      />
    );
  }

  return (
    <QuantityInput item={item} onIsQuantityUpdating={onIsQuantityUpdating} />
  );
};

export default QuantityEditable;
